import { SupplierService } from "../services";

const extractBuildingId = (params) => {
  if (!params) return undefined;
  if (typeof params === "number") return params;
  if (typeof params === "object") {
    if (typeof params.buildingId === "number") return params.buildingId;
    if (typeof params.buildingId === "object") return params.buildingId?.id;
    if (typeof params.building === "number") return params.building;
    if (typeof params.building === "object") return params.building?.id;
    if (typeof params.id === "number") return params.id;
  }
  return undefined;
};

export const supplier = {
  state: () => ({
    suppliers: [],
    selectedSuppliers: [],
    current: null,
  }),
  mutations: {
    setSuppliers: (state, value) => (state.suppliers = value || []),
    setSelectedSuppliers: (state, value) => (state.selectedSuppliers = value || []),
    setCurrentSupplier: (state, value) => (state.current = value || null),
  },
  actions: {
    SUPPLIER_FIND_ALL: async ({ commit }, params = {}) => {
      const response = await SupplierService.findAll(params);
      if (response.ok) {
        commit("setSuppliers", response.data || []);
      } else {
        alert(response.message || "No fue posible obtener los proveedores");
      }
      return response;
    },
    SUPPLIER_FIND_ONE: async ({ commit }, id) => {
      const response = await SupplierService.findById(id);
      if (response.ok) {
        commit("setCurrentSupplier", response.data || null);
      } else {
        alert(response.message || "No fue posible obtener el proveedor");
      }
      return response;
    },
    SUPPLIER_CREATE: async ({ dispatch }, payload) => {
      const response = await SupplierService.create(payload);
      if (response.ok) {
        const buildingId = extractBuildingId(payload?.buildingId ?? payload);
        if (buildingId) {
          await dispatch("SUPPLIER_FIND_ALL", { buildingId });
        }
      }
      return response;
    },
    SUPPLIER_UPDATE: async ({ dispatch }, { id, ...payload }) => {
      const response = await SupplierService.update({ id, ...payload });
      if (response.ok) {
        const buildingId = extractBuildingId(payload?.buildingId ?? payload);
        if (buildingId) {
          await dispatch("SUPPLIER_FIND_ALL", { buildingId });
        }
      }
      return response;
    },
    SUPPLIER_DELETE: async ({ dispatch }, { id, buildingId }) => {
      const response = await SupplierService.remove(id);
      if (response.ok) {
        const resolvedBuildingId = extractBuildingId(buildingId);
        if (resolvedBuildingId) {
          await dispatch("SUPPLIER_FIND_ALL", { buildingId: resolvedBuildingId });
        }
      }
      return response;
    },
    SUPPLIER_DOWNLOAD_EXCEL: async (_, payload) => SupplierService.downloadExcel(payload),
  },
  getters: {
    supplierById: (state) => (id) => state.suppliers.find((supplier) => supplier.id === id) || null,
  },
};
